import { useRecommendations } from '@hooks/useRecommendations'
import { UsePlatformSpecificPropsInput } from '../types/darkcove'

export type UseVideoRecomendationsInputProps = Partial<
  Pick<UsePlatformSpecificPropsInput, 'isBlickTV'>
>

export type UseVideoRecomendationsOutputProps = {
  videoRecommendations: ReturnType<typeof useRecommendations>['embedded-videos']
}

const useVideoRecomendations = ({
  isBlickTV,
}: UseVideoRecomendationsInputProps): UseVideoRecomendationsOutputProps => {
  const { 'embedded-videos': videoRecommendations } = useRecommendations({
    forceDisable: !!isBlickTV,
  })

  return {
    videoRecommendations,
  }
}

export default useVideoRecomendations
